if (!customElements.get('faq-items')) {
  customElements.define(
    'faq-items',
    class FaqItems extends HTMLElement {
      constructor() {
        super();

        this.items = this.querySelectorAll(".section-faq-item");

        this.items.forEach(this.addEventOnClick.bind(this));
        this.items.forEach(this.removeEventOnClickOnChildren.bind(this));
      }

      /**
       * 
       * @param {HTMLElement} item 
       */
      addEventOnClick(item) {
        const self = this;
        item.addEventListener("click", function (e) {
          self.hideAllItems(this);
          if (!this.hasAttribute("open")) {
            this.querySelector(".section-faq-item-content").style.height = this.querySelector(".section-faq-item-content-body").getBoundingClientRect().height + "px";
            this.setAttribute("open", "1")
          } else {
            this.querySelector(".section-faq-item-content").style.height = "0";
            this.removeAttribute("open");
          }
        })
      }

      /**
       * 
       * @param {HTMLElement} item 
       */
      removeEventOnClickOnChildren(item) {
        const self = this;
        item.querySelector(".section-faq-item-content").addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation()
          e.stopImmediatePropagation()
        })
      }

      /**
       * 
       * @param {HTMLElement} item 
       */
      hideAllItems(item) {
        this.items.forEach((current_item) => {
          if (item != current_item) {
            current_item.querySelector(".section-faq-item-content").style.height = "0";
            current_item.removeAttribute("open");
          }
        });
      }
    }
  );
}
